import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';

import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';
import { TARIFF_MODULE } from '../../configs/moduleNames';

export const LOAD_TARIFF_LIST = '_LOAD_TARIFF_LIST';
export const LOAD_TARIFF_BY_ID = '_LOAD_TARIFF_BY_ID';
export const CREATE_TARIFF = '_CREATE_TARIFF';
export const EDIT_TARIFF = '_EDIT_TARIFF';
export const DELETE_TARIFF = '_DELETE_TARIFF';
export const CALCULATE_TARIFF_COST = '_CALCULATE_TARIFF_COST';

export const LOAD_CALENDAR_DATE_LIST = '_LOAD_CALENDAR_DATE_LIST';
export const LOAD_CALENDAR_DATE_BY_ID = '_LOAD_CALENDAR_DATE_BY_ID';
export const CREATE_CALENDAR_DATE = '_CREATE_CALENDAR_DATE';
export const EDIT_CALENDAR_DATE = '_EDIT_CALENDAR_DATE';
export const DELETE_CALENDAR_DATE = '_DELETE_CALENDAR_DATE';

export const LOAD_DAILY_TARIFF_LIST = '_LOAD_DAILY_TARIFF_LIST';
export const LOAD_DAILY_TARIFF_BY_ID = '_LOAD_DAILY_TARIFF_BY_ID';
export const CREATE_DAILY_TARIFF = '_CREATE_DAILY_TARIFF';
export const EDIT_DAILY_TARIFF = '_EDIT_DAILY_TARIFF';
export const DELETE_DAILY_TARIFF = '_DELETE_DAILY_TARIFF';

export const LOAD_LOST_TICKET_LIST = '_LOAD_LOST_TICKET_LIST';
export const CREATE_LOST_TICKET = '_CREATE_LOST_TICKET';
export const EDIT_LOST_TICKET = '_EDIT_LOST_TICKET';
export const DELETE_LOST_TICKET = '_DELETE_LOST_TICKET';

export const createTariff = createDeferredAction(TARIFF_MODULE + CREATE_TARIFF);
export const createTariffSuccessful = createAction(TARIFF_MODULE + CREATE_TARIFF + SUCCESSFUL);
export const createTariffFailed = createAction(TARIFF_MODULE + CREATE_TARIFF + FAILED);

export const editTariff = createDeferredAction(TARIFF_MODULE + EDIT_TARIFF);
export const editTariffSuccessful = createAction(TARIFF_MODULE + EDIT_TARIFF + SUCCESSFUL);
export const editTariffFailed = createAction(TARIFF_MODULE + EDIT_TARIFF + FAILED);

export const deleteTariff = createDeferredAction(TARIFF_MODULE + DELETE_TARIFF);
export const deleteTariffSuccessful = createAction(TARIFF_MODULE + DELETE_TARIFF + SUCCESSFUL);
export const deleteTariffFailed = createAction(TARIFF_MODULE + DELETE_TARIFF + FAILED);

export const calculateTariffCost = createDeferredAction(TARIFF_MODULE + CALCULATE_TARIFF_COST);
export const calculateTariffCostSuccessful = createAction(TARIFF_MODULE + CALCULATE_TARIFF_COST + SUCCESSFUL);
export const calculateTariffCostFailed = createAction(TARIFF_MODULE + CALCULATE_TARIFF_COST + FAILED);

export const loadTariffList = createDeferredAction(TARIFF_MODULE + LOAD_TARIFF_LIST);
export const loadTariffListBegin = createAction(TARIFF_MODULE + LOAD_TARIFF_LIST + BEGIN);
export const loadTariffListSuccessful = createAction(TARIFF_MODULE + LOAD_TARIFF_LIST + SUCCESSFUL);
export const loadTariffListFailed = createAction(TARIFF_MODULE + LOAD_TARIFF_LIST + FAILED);

export const loadTariffById = createDeferredAction(TARIFF_MODULE + LOAD_TARIFF_BY_ID);
export const loadTariffByIdSuccessful = createAction(TARIFF_MODULE + LOAD_TARIFF_BY_ID + SUCCESSFUL);
export const loadTariffByIdFailed = createAction(TARIFF_MODULE + LOAD_TARIFF_BY_ID + FAILED);
export const loadTariffByIdClear = createAction(TARIFF_MODULE + LOAD_TARIFF_BY_ID + CLEAR);

export const createCalendarDate = createDeferredAction(TARIFF_MODULE + CREATE_CALENDAR_DATE);
export const createCalendarDateSuccessful = createAction(TARIFF_MODULE + CREATE_CALENDAR_DATE + SUCCESSFUL);
export const createCalendarDateFailed = createAction(TARIFF_MODULE + CREATE_CALENDAR_DATE + FAILED);

export const editCalendarDate = createDeferredAction(TARIFF_MODULE + EDIT_CALENDAR_DATE);
export const editCalendarDateSuccessful = createAction(TARIFF_MODULE + EDIT_CALENDAR_DATE + SUCCESSFUL);
export const editCalendarDateFailed = createAction(TARIFF_MODULE + EDIT_CALENDAR_DATE + FAILED);

export const deleteCalendarDate = createDeferredAction(TARIFF_MODULE + DELETE_CALENDAR_DATE);
export const deleteCalendarDateSuccessful = createAction(TARIFF_MODULE + DELETE_CALENDAR_DATE + SUCCESSFUL);
export const deleteCalendarDateFailed = createAction(TARIFF_MODULE + DELETE_CALENDAR_DATE + FAILED);

export const loadCalendarDateList = createDeferredAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_LIST);
export const loadCalendarDateListBegin = createAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_LIST + BEGIN);
export const loadCalendarDateListSuccessful = createAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_LIST + SUCCESSFUL);
export const loadCalendarDateListFailed = createAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_LIST + FAILED);

export const loadCalendarDateById = createDeferredAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_BY_ID);
export const loadCalendarDateByIdSuccessful = createAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_BY_ID + SUCCESSFUL);
export const loadCalendarDateByIdFailed = createAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_BY_ID + FAILED);
export const loadCalendarDateByIdClear = createAction(TARIFF_MODULE + LOAD_CALENDAR_DATE_BY_ID + CLEAR);

export const createDailyTariff = createDeferredAction(TARIFF_MODULE + CREATE_DAILY_TARIFF);
export const createDailyTariffSuccessful = createAction(TARIFF_MODULE + CREATE_DAILY_TARIFF + SUCCESSFUL);
export const createDailyTariffFailed = createAction(TARIFF_MODULE + CREATE_DAILY_TARIFF + FAILED);

export const editDailyTariff = createDeferredAction(TARIFF_MODULE + EDIT_DAILY_TARIFF);
export const editDailyTariffSuccessful = createAction(TARIFF_MODULE + EDIT_DAILY_TARIFF + SUCCESSFUL);
export const editDailyTariffFailed = createAction(TARIFF_MODULE + EDIT_DAILY_TARIFF + FAILED);

export const deleteDailyTariff = createDeferredAction(TARIFF_MODULE + DELETE_DAILY_TARIFF);
export const deleteDailyTariffSuccessful = createAction(TARIFF_MODULE + DELETE_DAILY_TARIFF + SUCCESSFUL);
export const deleteDailyTariffFailed = createAction(TARIFF_MODULE + DELETE_DAILY_TARIFF + FAILED);

export const loadDailyTariffList = createDeferredAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_LIST);
export const loadDailyTariffListBegin = createAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_LIST + BEGIN);
export const loadDailyTariffListSuccessful = createAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_LIST + SUCCESSFUL);
export const loadDailyTariffListFailed = createAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_LIST + FAILED);

export const loadDailyTariffById = createDeferredAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_BY_ID);
export const loadDailyTariffByIdSuccessful = createAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_BY_ID + SUCCESSFUL);
export const loadDailyTariffByIdFailed = createAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_BY_ID + FAILED);
export const loadDailyTariffByIdClear = createAction(TARIFF_MODULE + LOAD_DAILY_TARIFF_BY_ID + CLEAR);

export const loadLostTicketList = createDeferredAction(TARIFF_MODULE + LOAD_LOST_TICKET_LIST);
export const loadLostTicketListBegin = createAction(TARIFF_MODULE + LOAD_LOST_TICKET_LIST + BEGIN);
export const loadLostTicketListSuccessful = createAction(TARIFF_MODULE + LOAD_LOST_TICKET_LIST + SUCCESSFUL);
export const loadLostTicketListFailed = createAction(TARIFF_MODULE + LOAD_LOST_TICKET_LIST + FAILED);

export const createLostTicket = createDeferredAction(TARIFF_MODULE + CREATE_LOST_TICKET);
export const createLostTicketSuccessful = createAction(TARIFF_MODULE + CREATE_LOST_TICKET + SUCCESSFUL);
export const createLostTicketFailed = createAction(TARIFF_MODULE + CREATE_LOST_TICKET + FAILED);

export const editLostTicket = createDeferredAction(TARIFF_MODULE + EDIT_LOST_TICKET);
export const editLostTicketSuccessful = createAction(TARIFF_MODULE + EDIT_LOST_TICKET + SUCCESSFUL);
export const editLostTicketFailed = createAction(TARIFF_MODULE + EDIT_LOST_TICKET + FAILED);

export const deleteLostTicket = createDeferredAction(TARIFF_MODULE + DELETE_LOST_TICKET);
export const deleteLostTicketSuccessful = createAction(TARIFF_MODULE + DELETE_LOST_TICKET + SUCCESSFUL);
export const deleteLostTicketFailed = createAction(TARIFF_MODULE + DELETE_LOST_TICKET + FAILED);
